import { useEffect, useState } from "react";

interface FloatingCTAButtonProps {
  offersRef: React.RefObject<HTMLDivElement | null>;
}

export function FloatingCTAButton({ offersRef }: FloatingCTAButtonProps) {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (offersRef.current) {
        const offersRect = offersRef.current.getBoundingClientRect();
        const hasScrolledPastEntireOffers = offersRect.bottom <= 0;
        setShowFloatingCTA(hasScrolledPastEntireOffers);
      }
    };

    // Initial check
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [offersRef]);

  const scrollToOffers = () => {
    if (offersRef.current) {
      offersRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={scrollToOffers}
      className={`fixed bottom-20 right-2 sm:bottom-5 sm:right-6 z-50 px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg hover:shadow-xl flex items-center gap-2 group transition-all duration-300 transform ${
        showFloatingCTA
          ? "opacity-100 translate-y-0 scale-100"
          : "opacity-0 translate-y-4 scale-95 pointer-events-none"
      }`}
      aria-label="Get Paid Today"
    >
      <img
        src="/airplane-icon.svg"
        alt="Airplane"
        className="w-6 h-6 transform group-hover:scale-110 transition-transform duration-200"
      />
      <span className="text-[16px] font-medium whitespace-nowrap">
        Get Paid Today
      </span>
    </button>
  );
}
